export interface MessageGroupHeaderProps {
  children: React.ReactNode
}

export function MessageGroupHeader ({ children }: MessageGroupHeaderProps): JSX.Element {
  return (
    <div className='flex flex-row items-center justify-center py-3'>
      <span className='font-inter font-medium text-xs rounded-full bg-white text-gray-700 py-1.5 px-3 shadow'>
        {children}
      </span>
    </div>
  )
}
